import { Slot } from '@farol-ds/react'
import classNames from 'classnames'
import { HTMLAttributes } from 'react'

import styles from './list-block.module.scss'

export type ListBlockTextElement = HTMLSpanElement

export type ListBlockTextProps = HTMLAttributes<ListBlockTextElement> & {
  asChild?: boolean
}

function ListBlockText(props: ListBlockTextProps) {
  const { children, className, asChild, ...rest } = props
  const classes = classNames(styles.text, className)

  const Component = asChild ? Slot : 'span'

  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  )
}

export default ListBlockText
